import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '两会云问答';
const baseUrl = '2022LHYWD';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
